module.exports = __webpack_public_path__ + "static/assets/56891d1a0531017aba414c99a65690cc.gif";